import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MovingImageService } from './moving-image.service'

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    MovingImageService
  ]
})
export class MovingImageModule {
}
